import { AppContext } from '@ctsu/loader';
import { useContext } from 'react';


const useIsCTSUUser = () => {
  const context = useContext(AppContext);
  const { session } = context;
  return session?.userGroups?.indexOf("CTSU") > -1;
};

export default useIsCTSUUser;



export const useValidateUserRole = (roles) => {
  const context = useContext(AppContext);
  const { session } = context;
  const userRoles = session?.userSiteRolePermissions?.map(siteRole => siteRole?.roles?.map(r => r?.displayName?.trim()))?.flat() || []
  return userRoles?.some(role => roles.map(r => r.toLowerCase()).includes(role.toLowerCase()));
}

export function useCurrentUser() {
  const context = useContext(AppContext);
  const { session } = context;
  let userFirstLast = "";
  if (session) {
    userFirstLast = session.userFirstLast;
  }
  return userFirstLast;
}